import { Component } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {FormGroup,FormControl,Validators } from '@angular/forms';
import {MatSnackBar} from '@angular/material';


import { AngularFireAuth } from '@angular/fire/auth';
import { User } from '../../models/models';



/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  styleUrls: ['./login.scss']

})
export class LoginPage {
	
	user = {} as User;	
	formLogin: FormGroup;
	
	constructor(private route: ActivatedRoute,
	private router: Router,
	private afAuth: AngularFireAuth,
	public snackBar: MatSnackBar) {
	   
		this.formLogin = new FormGroup({			
			'email': new FormControl(null, [Validators.required]),
			'password': new FormControl(null, Validators.required)
		});
	}

	login() {
		if(this.formLogin.invalid) return false; 

		let user = this.formLogin.value as User;
		
		this.afAuth.auth.signInWithEmailAndPassword(user.email, user.password).then(result=>{
			if (result) {
				this.router.navigate(['/write']);
			}  
		}).catch(e=>{
			this.snackBar.open(e.message,"Fechar",{duration: 3000}).onAction().subscribe(() => {
				this.snackBar.dismiss();
			});
		});
	}  
}
